import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CourseTableRow from "../../Props/CourseTableRow";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CHAT_LIST_FETCH_SUCCESS } from "../../Reducer/chatListSlice";
import API from "../../Network/API";
import { UPCOMING_ENROLLMENT_FETCH_START, UPCOMING_ENROLLMENT_FETCH_SUCCESS } from "../../Reducer/upcomingEnrollmentSlice";
import { MY_COURSE_FETCH_START, MY_COURSE_FETCH_SUCCESS, MY_COURSE_TOTAL_PAGE } from "../../Reducer/myCourseSlice";

export default function TutorHome() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.authReducer);
  const select_course = useSelector((state) => state.myCourseReducer);
  const select_upcoming_course = useSelector((state) => state.upcomingEnrollmentReducer);
  const totalEnrollment = select_course?.courses?.reduce((sum, course) => sum + (course.total_enrollment ?? 0), 0) ?? 0;
  const upcoming = select_upcoming_course?.courses || [];
  const dispatch = useDispatch();

  useEffect(() => {
    API.get(`/v1/oauth/chatlist`).then((response) => {
      dispatch(CHAT_LIST_FETCH_SUCCESS(response.data.data))
    }).catch(() => {});

    dispatch(UPCOMING_ENROLLMENT_FETCH_START());
    API.get(`/v1/oauth/teacher/upcoming_course`).then((response) => {
      dispatch(UPCOMING_ENROLLMENT_FETCH_SUCCESS(response.data.data))
    }).catch(() => {
      dispatch(UPCOMING_ENROLLMENT_FETCH_SUCCESS({ courses: [] }))
    });

    // course totals used to stay at 0 until "My courses" had been opened once
    dispatch(MY_COURSE_FETCH_START());
    API.get(`/v1/oauth/teacher/mycourses`).then((response) => {
      dispatch(MY_COURSE_FETCH_SUCCESS(response.data.data))
      dispatch(MY_COURSE_TOTAL_PAGE(response.data.data.total_page))
    }).catch(() => {});
  }, [dispatch]);

  const stats = [
    { icon: "fa-users", label: t("dashHome.total_students"), value: totalEnrollment, tone: 1 },
    { icon: "fa-book-open", label: t("dashHome.total_courses"), value: select_course?.data?.total ?? 0, tone: 2 },
    { icon: "fa-wallet", label: t("dashHome.balance"), value: `$${user?.balance ?? 0}`, tone: 3 },
  ];

  return (
    <div className="dh">
      <div className="row g-3">
        {stats.map((stat) => (
          <div className="col-md-4" key={stat.label}>
            <div className="dh-stat">
              <span className={`dh-stat-icon dh-tone-${stat.tone}`}><i className={`fa-light ${stat.icon}`} /></span>
              <div>
                <span className="dh-stat-value">{stat.value}</span>
                <span className="dh-stat-label">{stat.label}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="dh-section-head">
        <h2>{t("dashHome.upcoming_classes")}</h2>
        <Link to="/dashboard/all-enrollment-courses" className="dh-link">
          {t("dashHome.view_classes")} <i className="fa-light fa-arrow-right" />
        </Link>
      </div>

      {select_upcoming_course?.loading ? (
        <div className="dh-empty dh-empty--compact">
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> {t("dashHome.loading")}
        </div>
      ) : upcoming.length === 0 ? (
        <div className="dh-empty">
          <span className="dh-empty-icon dh-tone-2"><i className="fa-light fa-calendar" /></span>
          <h3>{t("dashHome.empty_tutor_title")}</h3>
          <p>{t("dashHome.empty_tutor_desc")}</p>
          <Link to="/dashboard/my-course/create" className="dh-btn">{t("dashHome.create_course")}</Link>
        </div>
      ) : (
        <div className="table-responsive custom-table">
          <table className="table table-nowrap mb-0">
            <thead>
              <tr>
                <th>{t("tutorHome.type")}</th>
                <th>{t("tutorHome.student")}</th>
                <th>{t("tutorHome.title")}</th>
                <th>{t("tutorHome.lesson_name")}</th>
                <th>{t("tutorHome.start_time")}</th>
                <th>{t("tutorHome.remaining")}</th>
                <th>{t("tutorHome.action")}</th>
              </tr>
            </thead>
            <tbody>
              {upcoming.map((course, j) => (
                <CourseTableRow data={course} key={j} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
